import { Helmet } from 'react-helmet';
import { CreateContainer } from '../components/create.container';
import { useParams } from 'react-router-dom';
import { getItem } from '../../../../../../../shared/local-storage';
import { PageHeader } from '../../../../../../../shared/page-header';
import { SubPageLayout } from '../sub-page-layout';

interface CredentialCreateProps {}

export const CredentialCreate: React.FC<CredentialCreateProps> = () => {
  const applicantUserId = getItem('applicantUserId');
  const params = useParams();

  return (
    <SubPageLayout
      header={
        <PageHeader
          title=""
          subTitle="Credential Verification Request"
          description="If you are unable to provide all information and documentation in one session, or if you leave the application for any reason, the information and documentation you provided will be saved for approximately 24 hours. After that time, it will no longer be available and you will be required to begin a new request."
        />
      }
    >
      <Helmet>
        <title>Case - Draft</title>
      </Helmet>
      <CreateContainer caseId={params.caseId ?? ''} applicantUserId={applicantUserId ?? ''} />
    </SubPageLayout>
  );
};
